import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { LegacyCarousel } from '../components/LegacyCarousel';
import { Businesses } from '../components/Businesses';
import { Vision } from '../components/Vision';
import { Leadership } from '../components/Leadership';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';

export const Home = () => {
  return (
    <div style={{ background: 'var(--bg-primary)' }}>
      <SEO />
      <Header />
      <Hero />
      <LegacyCarousel />
      <Businesses />
      <Vision />
      <Leadership />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;